/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cardcontent[_ngcontent-%COMP%], .editsearch[_ngcontent-%COMP%]{position:relative;width:40%}.taxplustotal[_ngcontent-%COMP%]{position:relative;left:519px;top:107px}#closebutton[_ngcontent-%COMP%]{position:relative;width:61%;font-size:24px}.firebasespinner[_ngcontent-%COMP%]{position:relative;left:200px}.badge[_ngcontent-%COMP%]{font-size:20px}.button[_ngcontent-%COMP%]{font-size:18px;margin-top:8px;background-color:#228b22;color:#fff}"];
export { styles as styles };
